export const SUPPORTED_CURRENCIES = [
  { code: "GBP", symbol: "£", label: "British Pound (GBP)" },
  { code: "USD", symbol: "$", label: "US Dollar (USD)" },
  { code: "EUR", symbol: "€", label: "Euro (EUR)" },
  { code: "AUD", symbol: "$", label: "Australian Dollar (AUD)" },
  { code: "NZD", symbol: "$", label: "New Zealand Dollar (NZD)" },
  { code: "CAD", symbol: "$", label: "Canadian Dollar (CAD)" },
  { code: "SGD", symbol: "$", label: "Singapore Dollar (SGD)" },
  { code: "HKD", symbol: "$", label: "Hong Kong Dollar (HKD)" },
  { code: "ZAR", symbol: "R", label: "South African Rand (ZAR)" },
  { code: "INR", symbol: "₹", label: "Indian Rupee (INR)" },
];

const FALLBACK_SYMBOLS = SUPPORTED_CURRENCIES.reduce((acc, entry) => {
  acc[entry.code] = entry.symbol;
  return acc;
}, {});

export function normalizeCurrencyCode(code) {
  return (code || "GBP").toUpperCase();
}

export function getCurrencySymbol(code, supported = []) {
  const normalized = normalizeCurrencyCode(code);

  const catalogue = supported.length ? supported : SUPPORTED_CURRENCIES;
  const match = catalogue.find((entry) => entry.code === normalized);
  if (match?.symbol) {
    return match.symbol;
  }

  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency: normalized,
    }).formatToParts(0);
    const currencyPart = parts.find((part) => part.type === "currency");
    if (currencyPart?.value) {
      return currencyPart.value;
    }
  } catch {
    // Intl may not support this currency code; fall through to fallback map.
  }

  return FALLBACK_SYMBOLS[normalized] || "£";
}

export function formatCurrency(amount, currencyCode = "GBP", locale = "en") {
  const value = Number(amount ?? 0);
  const normalized = normalizeCurrencyCode(currencyCode);

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: normalized,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    const symbol = getCurrencySymbol(normalized);
    const formatted = value.toFixed(2);
    return symbol ? `${symbol}${formatted}` : `${normalized} ${formatted}`;
  }
}

export function summariseCurrencyUsage(value) {
  if (!value || typeof value !== "object") {
    return null;
  }
  const code = normalizeCurrencyCode(value.currencyCode || value.code);
  const symbol =
    value.currencySymbol ||
    getCurrencySymbol(code, value.supportedCurrencies || SUPPORTED_CURRENCIES);
  return { code, symbol };
}
